/**
 * HubSpot's official sprocket logomark — exact path data from Simple Icons
 * (simple-icons.org), the same source most web apps use for accurate brand
 * marks. Rendered as an MUI SvgIcon so it drops into the same size/color/sx
 * props every other icon in this app already uses, but kept as its OWN
 * component (never re-colored to the app's primary color) — the mark is
 * only ever shown at HubSpot's own brand orange, since it identifies HubSpot
 * itself, not a Baatly-branded action.
 */
import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

const HUBSPOT_ORANGE = '#FF7A59';

const HubSpotIcon: React.FC<SvgIconProps> = ({ htmlColor, ...props }) => (
  <SvgIcon viewBox="0 0 24 24" htmlColor={htmlColor ?? HUBSPOT_ORANGE} {...props}>
    <path d="M18.164 7.93V5.084a2.198 2.198 0 001.267-1.978v-.067A2.2 2.2 0 0017.238.845h-.067a2.2 2.2 0 00-2.193 2.193v.067a2.196 2.196 0 001.252 1.973l.013.006v2.852a6.22 6.22 0 00-2.969 1.31l.012-.01-7.828-6.095A2.497 2.497 0 104.3 4.656l-.012.006 7.697 5.991a6.176 6.176 0 00-1.038 3.446c0 1.343.425 2.588 1.147 3.607l-.013-.02-2.342 2.343a1.968 1.968 0 00-.58-.095h-.002a2.033 2.033 0 102.033 2.033 1.978 1.978 0 00-.1-.595l.005.014 2.317-2.317a6.247 6.247 0 104.782-11.134l-.036-.005zm-.964 9.378a3.206 3.206 0 113.215-3.207v.002a3.206 3.206 0 01-3.207 3.207z" />
  </SvgIcon>
);

export default HubSpotIcon;
